import { FinanceLabField } from "@/entities/FinanceLab/FinanceLab.model";
import { AccountLabel } from "@/entities/Labeling/Account.model";

export const BALANCE_SHEET_LABELS = new Set([
    AccountLabel.ASSETS,
    AccountLabel.CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS,
    AccountLabel.CURRENT_ASSETS_NET_RECEIVABLES,
    AccountLabel.CURRENT_ASSETS_NET_INVENTORY,
    AccountLabel.NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT,
    AccountLabel.LIABILITIES,
    AccountLabel.CURRENT_LIABILITIES_ACCOUNTS_PAYABLE,
    AccountLabel.CURRENT_LIABILITIES_DEBT,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_CASH,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_TOTAL_LIABILITIES,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_CASH,
]);

export const INCOME_STATEMENT_LABELS = new Set([
    AccountLabel.REVENUES,
    AccountLabel.EBITDA,
    AccountLabel.EBITDA_MARGIN,
    AccountLabel.GROSS_MARGIN,
    AccountLabel.NET_INCOME,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_TOTAL_REVENUE,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_EBITDA,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_NET_INCOME,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_NET_INCOME_MARGIN_P,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_EBITDA_MARGIN_P,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_GROSS_MARGIN_P,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_SALES_AND_MARKETING_EFFICIENCY,
]);

export const POST_CLOSING_METRICS_LABELS = new Set([
    FinanceLabField.DEAL_INTEREST_COVERAGE,
    FinanceLabField.DEAL_DSCR,
    FinanceLabField.DEAL_GROSS_DEBT_TO_ASSETS,
    FinanceLabField.DEAL_GROSS_DEBT_TO_EBITDA,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS_TO_EQUITY,
    FinanceLabField.DEAL_DEBT_TO_EQUITY,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_CASH_BURN_MONTHLY,
]);

export const PROJECTED_FINANCIALS_METRICS_LABELS = new Set([
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_TOTAL_REVENUE,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_EBITDA_MARGIN_P,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_GROSS_MARGIN_P,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_CASH,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_EBITDA,
    FinanceLabField.ORGANIZATION_FINANCIAL_DATA_PROJECTIONS_HUM_BASE_CASE_SALES_AND_MARKETING_EFFICIENCY,
]);
